import React from 'react'
import { Card, Row, Col, Statistic, Typography, Spin, Empty } from 'antd'
import { AndroidOutlined, AppleOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'

const { Text } = Typography

const pct = (part, total) =>
  total ? `${((part / total) * 100).toFixed(1)}%` : '—'

const LeadCard = ({ title, hint, color, group, total }) => (
  <Card
    size="small"
    title={<Text style={{ color }}>{title}</Text>}
    style={{ borderTop: `3px solid ${color}` }}
  >
    <Row gutter={12}>
      <Col span={8}>
        <Statistic
          title={
            <span>
              <AndroidOutlined /> Android
            </span>
          }
          value={group.android}
          valueStyle={{ color }}
        />
      </Col>
      <Col span={8}>
        <Statistic
          title={
            <span>
              <AppleOutlined /> iOS
            </span>
          }
          value={group.ios}
          valueStyle={{ color }}
        />
      </Col>
      <Col span={8}>
        <Statistic
          title="Всего"
          value={group.total}
          valueStyle={{ color, fontWeight: 700 }}
        />
      </Col>
    </Row>
    <div style={{ marginTop: 8 }}>
      <Text type="secondary" style={{ fontSize: 12 }}>
        Доля от всех: <b style={{ color }}>{pct(group.total, total)}</b> ·{' '}
        {hint}
      </Text>
    </div>
  </Card>
)

LeadCard.propTypes = {
  title: PropTypes.string.isRequired,
  hint: PropTypes.string,
  color: PropTypes.string,
  group: PropTypes.object.isRequired,
  total: PropTypes.number
}

const QualitySection = ({ stats, loading }) => (
  <Spin spinning={loading}>
    <Card size="small" style={{ marginBottom: 16, textAlign: 'center' }}>
      <Statistic
        title="Всего пользователей за период"
        value={stats ? stats.total : '—'}
        valueStyle={{ fontSize: 28, fontWeight: 700 }}
      />
    </Card>

    {stats ? (
      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col xs={24} md={12}>
          <LeadCard
            title="Качественные лиды"
            hint="язык и платформа заданы"
            color="#52c41a"
            group={stats.quality}
            total={stats.total}
          />
        </Col>
        <Col xs={24} md={12}>
          <LeadCard
            title="Некачественные лиды"
            hint="язык или платформа = none"
            color="#ff4d4f"
            group={stats.lowQuality}
            total={stats.total}
          />
        </Col>
      </Row>
    ) : (
      !loading && <Empty description="Нет данных за период" />
    )}
  </Spin>
)

QualitySection.propTypes = {
  stats: PropTypes.object,
  loading: PropTypes.bool
}

export default QualitySection
